module.exports = __webpack_public_path__ + "media/icons/active_download-976c409d.svg";